<template>
  <GpModal
    :is-opened="show"
    :header-icon="['fas', 'fa-key']"
    header-text="Client secret"
    @close="$emit('close')"
  >
    <template #content>
      <div class="tw-mb-8 tw-px-4">
        <GpAlert
          alert-type="warning"
          size="sm"
          class="tw-mb-2"
          message="Please save the client secret in a safe place. You will not be able to see it again."
        />

        <GpTextInput
          class="tw-mb-4"
          readonly
          label="Client ID"
          :model-value="clientId"
          name="id"
          input-id="client-id"
        >
          <template #actions>
            <GpInputBtn :icon="['fas', 'fa-copy']" @click="copyToClipboard(clientId)" />
          </template>
        </GpTextInput>
        <GpTextInput
          readonly
          label="Client secret"
          :model-value="clientSecret"
          name="secret"
          input-id="client-secret"
        >
          <template #actions>
            <GpInputBtn :icon="['fas', 'fa-copy']" @click="copyToClipboard(clientSecret)" />
          </template>
        </GpTextInput>
      </div>
    </template>
    <template #footer>
      <ModalFooterBtn
        class="tw-block"
        label="Close"
        btn-type="cancel"
        @click="$emit('close')"
        v-playwright="'client-secret-close-btn'"
      />
    </template>
  </GpModal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { GpAlert, GpInputBtn, GpModal, GpTextInput } from '@gportal/uikit';
import ModalFooterBtn from 'gpcore-uikit/components/new/ModalFooterBtn.vue';
import { useClipboard } from '@vueuse/core';

export default defineComponent({
  emits: ['close'],
  components: {
    ModalFooterBtn,
    GpTextInput,
    GpModal,
    GpAlert,
    GpInputBtn,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    clientId: {
      type: String,
      default: '',
    },
    clientSecret: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { copy: copyToClipboard } = useClipboard();

    return {
      copyToClipboard,
    };
  },
});
</script>
